module.exports = __webpack_public_path__ + "img/album18_54.984f99cb.jpg";